import { createContext } from "react";

export const InvitationContext = createContext(false);
